export default {
  'BrandKit': 'BrandKit',
  'BrandKit.title': 'Biconomy’s Brand Kit',
  'BrandKit.banner':
    'We have developed simple brand guidelines to help our partners and ambassadors collaborate with us and help us increase our brand awareness, so that later we can develop cutting-edge technologies for you.',
  'BrandKit.banner.btn': 'Ask about collaboration options',
  'BrandKit.li_title': 'Guiding Principles',
  'BrandKit.li_text': 'We put function over form and simplicity over complication.',
  'BrandKit.li_title_1': 'Simplicity',
  'BrandKit.li_text_1':
    'When there is a design, or product trade-off, simplicity is our guiding principle, as we believe that technology should be accessible to everyone.',
  'BrandKit.li_title_2': 'Usability',
  'BrandKit.li_text_2': 'We believe that technologies are made to make people’s life easier, so we make sure our product is always usable.',
  'BrandKit.li_title_3': 'Functionality',
  'BrandKit.li_text_3':
    'Our goal is to keep up with the latest technologies and help our users achieve their goals, so we always try to make sure that our product is functional.',
  'BrandKit.li_title_4': 'Feedback',
  'BrandKit.li_text_4':
    'We want to make sure that our users always know the consequences of their actions, so we prioritze proper feedback.',
  'BrandKit.download': 'Downloadables',
  'BrandKit.down.title_1': 'Brand Styleguide',
  'BrandKit.down.text_1': 'Learn how to use Biconomy assets in collaborative projects, or for promotion',
  'BrandKit.down.style': 'Download the Styleguide',
  'BrandKit.down.title_2': 'Biconomy Logo Pack',
  'BrandKit.down.text_2': 'Learn how to use Biconomy assets in collaborative projects, or for promotion',
  'BrandKit.down.svg': 'Download zipped SVG',
  'BrandKit.down.png': 'Download zipped PNG',
  'BrandKit.down.title_3': 'BIT Logo Pack',
  'BrandKit.down.text_3': 'Learn how to use Biconomy assets in collaborative projects, or for promotion',
  'BrandKit.start': 'Start downloading',
  'BrandKit.down.title_4': 'Print Out our Brand',
};
